import { Box, OutlinedInput } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { useEffect, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from '../components/MainContent';
import { workerPageName } from "../components/PageName";
import FormDropDownList from "../components/FormDropDownList";
import { useLazyGetFileQuery, useLazyGetWorkerDropdownListQuery, useLazyGetWorkerFileQuery, useLazyGetWorkerListingQuery } from "../features/worker/workerSlice";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { WorkerAsDropdownListItemModel, WorkerListingModel } from "../models/WorkerModel";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { pdfIcon, qrcodeIcon } from "../assets/imgs";
import SearchDropDownList from "../components/SearchDropDownList";
import RecordTableV2 from "../components/RecordTableV2";
import { RecordModel } from "../models/RecordModel";
import { useTranslation } from "react-i18next";

const WorkerListPage = () => {
    const { t, i18n } = useTranslation();
    const [rfidNumber, setRfidNumber] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [workerName, setWorkerName] = useState("");
    const [dropdownListItems, setDropdownListItems] = useState([])
    const [rows, setRows] = useState<any[]>([])
    const [counter, setCounter] = useState(0)
    const [getWorkerFile, getWorkerFileResult] = useLazyGetFileQuery()
    const [getWorkerDropdownListQuery, {
        data: dropdownList,
        error: getDropdownListError,
        isError: isErrorGetDropdownList,
        isFetching: isFetchingDropdownList,
        isSuccess: isSuccessGetDropdownList,
        isLoading: isLoadingDropdownList
    }] = useLazyGetWorkerDropdownListQuery();
    const [getWorkerListingQuery, {
        data: workerListing,
        error: getWorkerListingError,
        isError: isErrorGetWorkerListing,
        isFetching: isFechingWorkerListing,
        isSuccess: isSuccessGetWorkerListing,
        isLoading: isLoadingWorkerListing
    }] = useLazyGetWorkerListingQuery();
    // const [getWorkerListingQuery] = useLazyGetWorkerListingQuery();
    const navigate = useNavigate();
    const columns: TableHeader[] | any = [
        { field: 'workerName', headerName: t('Worker Name'), width: 200, isSortable: true },
        { field: 'companyName', headerName: t('Company Name'), width: 300, isSortable: true },
        // { field: 'rfid', headerName: t('RFID No.'), width: 300, isSortable: false },
        // {
        //     field: 'certification',
        //     headerName: 'Certification',
        //     width: 300,
        //     isSortable: false,
        //     renderCell: (params: GridRenderCellParams<any, Date>) => {
        //         if (params?.row?.certification != null) {
        //             return (
        //                 <button style={{ border: 'none', background: 'none' }} onClick={() => fileUrl(params?.row?.certification)} >
        //                     <img src={pdfIcon} />
        //                 </button>
        //             )
        //         }
        //     }
        // },
        // { field: 'qrCode', headerName: 'QR Code', width: 300, isSortable: false, renderCell: (params: GridRenderCellParams<any, Date>) => <img src={qrcodeIcon}></img> },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getWorkerListingQuery(
            {
                workerName: workerName,
                // rfidNumber: rfidNumber,
                companyName: companyName,
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                workerId: item.id,
                workerName: item.workerName,
                companyName: item.companyName,
                // rfid: item.rfidNumber,
                certification: item.certifiedConfinedWorkFileId,
            }))
        }
        // return [];
    };

    const handleTableData = async () => {
        try {
            console.log("getting data")
            if (localStorage.accessToken) {
                getWorkerDropdownListQuery();
                getWorkerListingQuery({
                    workerName: workerName,
                    rfidNumber: rfidNumber,
                    companyName: companyName
                }).then(
                    (res) => {
                        if (res.status == 'fulfilled') {

                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.id,
                                workerId: item.id,
                                workerName: item.workerName,
                                companyName: item.companyName,
                                rfid: item.rfidNumber,
                                certification: item.certifiedConfinedWorkFileId,
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }

    // useEffect(() => {
    //     getWorkerDropdownListQuery();
    //     getWorkerListingQuery({
    //         workerName: workerName,
    //         rfidNumber: rfidNumber,
    //         companyName: companyName
    //     })
    // }, [counter])

    useEffect(() => {

        handleTableData()
        // console.log("data", data)
    }, []);

    useEffect(() => {
        if (isSuccessGetDropdownList) {
            const workerNames = dropdownList.map((item: WorkerAsDropdownListItemModel) => item.workerName)
            setDropdownListItems(workerNames)
        }
    }, [dropdownList])

    // useEffect(() => {
    //     if (isSuccessGetWorkerListing) {
    //         console.log(workerListing)
    //         const tableRows = (workerListing as WorkerListingModel).records.map((item) => ({
    //             workerId: item.id,
    //             workerName: item.workerName,
    //             companyName: item.companyName,
    //             rfid: item.rfidNumber,
    //             // certificateName: 'Certification',
    //             certification: item.certifiedConfinedWorkFileId,
    //             // qrCode: 'QR Code'
    //         }))
    //         setRows(tableRows)
    //     }
    // }, [workerListing])

    useEffect(() => {
        if (isErrorGetDropdownList) {
            alert('Fails to fetch dropdown list data from API.')
            console.error((getDropdownListError as FetchBaseQueryError))
        }
    }, [getDropdownListError])

    useEffect(() => {
        if (isErrorGetDropdownList) {
            alert('Fails to fetch worker list data from API.')
            console.error((getWorkerListingError as FetchBaseQueryError))
        }
    }, [getWorkerListingError])

    // const handleSearch = function () {
    //     setCounter(counter + 1)
    // }

    const handleRowClick = (worker: any, field?: string) => {
        if (!(field != undefined && (field == 'certification' || field == '__check__'))) {
            navigate('/worker-detail', { state: { workerID: worker.workerId } });
        }
    };

    const fileUrl = (Id: string) => {
        getWorkerFile(Id).then((res) => {
            console.log(res);
            if (res?.data != undefined) {
                const link = document.createElement('a');
                link.href = res?.data?.url;
                link.click();
            }
        })
    }

    return (
        <MainContent type={workerPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Worker")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchDropDownList
                                    title={t("Worker Name")}
                                    value={workerName}
                                    handleValueChange={(event: any) => { setWorkerName(event.target.value) }}
                                    items={dropdownListItems}
                                />
                                <SearchInput title={t("Company Name")} value={companyName} setMethod={setCompanyName} />
                                {/* <SearchInput title={t("RFID No.")} value={rfidNumber} setMethod={setRfidNumber} /> */}
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={() => handleTableData()}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={() => { navigate('/add-worker') }}>{t("Add New Worker")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* <RecordTable getRowId={e => e.workerId} columns={columns} rows={rows} checkbox={true} onClick={handleRowClick}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};
export default WorkerListPage;